import { ERROR_MESSAGES } from 'public/i18n/error-messages';
import { SUCCESS_MESSAGES } from 'public/i18n/success-messages';
import { Injectable } from '@angular/core';
import { Language } from '../common/languages.config';
import { LanguageService } from './language.service';

@Injectable({ providedIn: 'root' })
export class ErrorMessageService {
  constructor(private readonly languageService: LanguageService) {}

  getErrorMessage(key: keyof typeof ERROR_MESSAGES): string {
    const language: Language = this.languageService.currentLanguage();
    const messages = ERROR_MESSAGES[key];
    return messages[language] || messages['hr'];
  }

  getSuccessMessage(key: keyof typeof SUCCESS_MESSAGES): string {
    const language: Language = this.languageService.currentLanguage();
    const messages = SUCCESS_MESSAGES[key];
    return messages[language] || messages['hr'];
  }
}